module.exports = __webpack_public_path__ + "static/media/94.91b1defa.jpg";